import { AppError } from "config/errors";
import { statesQuery } from "gql/queries/states";

import { createAsyncThunk } from "@reduxjs/toolkit";

/* ------------       THUNKS      ------------------ */

export const getStates = createAsyncThunk(
  "states/getStates",
  async (countryId: string, { rejectWithValue }) => {
    try {
      const response = await statesQuery(countryId);

      return response.data?.states || [];
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
